export function variacaoCustoOba(valor) {
  if (valor > 0) {
    return "%";
  }
  const valorn = Number(valor.replace(",", ".")) * 100;
  return valorn.toFixed(1) + "%";
}
